import React         from 'react';
import ContactHeader from 'Widgets/ContactHeader';
import ContactForm   from 'Widgets/ContactForm';
import ContactMap    from 'Widgets/ContactMap';

export default function Contact() {
    return (
        <div>
            <section role="main">
                <ContactHeader />
            </section>

            <section role="main" className="contact-background">
                <div className="grid-center contact-details">
                    <div className="col-5_xs-11_sm-11_md-11">
                        <ContactMap />
                    </div>
                    <div className="col-5_xs-11_sm-11_md-11">
                        <ContactForm />
                    </div>
                </div>
            </section>
        </div>
    );
};
